<template>
      <div class="view-container">
        <div class="view-box">
            <div class="view-row">
            <div class="view-field">
                <div class="view-label">项目编号</div>
                <div  style="color: #999999;">{{project.projectcode}}</div>
            </div>
            <div class="view-field">
                <div class="view-label">项目名称</div>
                <div style="color: #999999;">{{project.projectname}}</div>
            </div>
            </div>
            <div class="view-row">
            <div class="view-field">
                <div class="view-label">采购人</div>
                <div  style="color: #999999;">{{project.pcomfullname}}</div>
            </div>
            </div>
            <div class="view-row">
            <div class="view-field">
                <div class="view-label">交易方式</div>
                <div  style="color: #999999;">{{project.prsflgdesc}}——{{project.projectdoneflgdesc}}<span v-if="project.prsflg !== '2' && project.prsflg !== '6'">——{{project.projectpricecomputebasisdesc}}</span><span v-if="project.projectaveragepriceshift">——平均价浮动率:{{project.projectaveragepriceshift}}</span></div>
            </div>
            </div>
            <div class="view-row">
            <div class="view-field">
                <div class="view-label">项目预算</div>
                <div  style="color: #999999;">
                    <span v-if="project.projectlimitamt">
                        ￥{{ project.projectlimitamt | qfwVal }}元 （
                        <amount :money="String(project.projectlimitamt)" />
                    ）
                    </span>
                </div>
            </div>
            </div>
        </div>
      </div>
</template>
<script>
import amount from '../common/amount'
export default {
  name: 'formRule',
  components: { amount },
  props:{
      project:{}
  },
  data () {
   return {
      
   }
  }
}
</script>
<style lang="scss" scoped>

</style>
